import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calcul des protéines : Calculez vos besoins quotidiens en protéines";
const DESCRIPTION =
  "Calcul des protéines : Calculez vos besoins quotidiens en protéines en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "calcul des protéines vos besoins quotidiens en protéines, calculatrice calcul des protéines vos besoins quotidiens en protéines, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/protein/";
const data1 = [
  { ageGroup: "1 à 3", proteinNeeded: 13 },
  { ageGroup: "4 à 8", proteinNeeded: 19 },
  { ageGroup: "9 à 13", proteinNeeded: 34 },
  { ageGroup: "14 à 18 (filles)", proteinNeeded: 46 },
  { ageGroup: "14 à 18 (garçons)", proteinNeeded: 52 },
  { ageGroup: "19 à 70+ (femmes)", proteinNeeded: 46 },
  { ageGroup: "19 à 70+ (hommes)", proteinNeeded: 56 },
];
function ProteinCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("sedentary");
  const [resultADA, setResultADA] = useState(null);
  const [resultCDC, setResultCDC] = useState(null);
  const [resultWHO, setResultWHO] = useState(null);
  const [ageError, setAgeError] = useState("");
  const [heightError, setHeightError] = useState("");
  const [weightError, setWeightError] = useState("");
  const handleAgeChange = (event) => {
    const inputAge = event.target.value;
    if (inputAge !== "") {
      const parsedAge = parseInt(inputAge, 10);
      if (!isNaN(parsedAge) && parsedAge >= 18 && parsedAge <= 85) {
        setAge(inputAge);
        setAgeError("");
      } else {
        setAge("");
        if (isNaN(parsedAge)) {
          setAgeError("Assurez-vous d'entrer un nombre");
        } else if (parsedAge < 18) {
          setAge(inputAge);
          setAgeError("L'âge doit être entre 18 - 85");
        } else if (parsedAge > 85) {
          setAge(inputAge);
          setAgeError("L'âge doit être entre 18 - 85");
        }
      }
    } else {
      setAge("");
      setAgeError("");
    }
  };
  const handleHeightChange = (event) => {
    const inputHeight = event.target.value;
    if (inputHeight !== "") {
      if (!isNaN(inputHeight)) {
        setHeight(inputHeight);
        setHeightError("");
      } else {
        setHeight("");
        if (isNaN(inputHeight)) {
          setHeightError("Assurez-vous d'entrer un nombre");
        }
      }
    } else {
      setHeight("");
      setHeightError("");
    }
  };
  const handleWeightChange = (event) => {
    const inputWeight = event.target.value;
    if (inputWeight !== "") {
      if (!isNaN(inputWeight)) {
        setWeight(inputWeight);
        setWeightError("");
      } else {
        setWeight("");
        if (isNaN(inputWeight)) {
          setWeightError("Assurez-vous d'entrer un nombre");
        }
      }
    } else {
      setWeight("");
      setWeightError("");
    }
  };
  const calculateProtein = () => {
    const proteinIntakeADA = calculateProteinIntakeADA(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeCDC = calculateProteinIntakeCDC(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeWHO = calculateProteinIntakeWHO(
      age,
      gender,
      weight,
      activity,
      height
    );
    return {
      proteinIntakeADA: proteinIntakeADA,
      proteinIntakeCDC: proteinIntakeCDC,
      proteinIntakeWHO: proteinIntakeWHO,
    };
  };
  const calculateProteinIntakeADA = (age, gender, weight, activity) => {
    let proteinIntakeMin = 0;
    let proteinIntakeMax = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        if (activity === "sedentary") {
          proteinIntakeMin = weight * 0.8;
          proteinIntakeMax = weight * 1.0;
        } else {
          proteinIntakeMin = weight * 1.0;
          proteinIntakeMax = weight * 1.8;
        }
      }
    }
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeCDC = (age, gender, weight, activity, height) => {
    let bmr = 0;
    if (gender === "male") {
      bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else if (gender === "female") {
      bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    }
    let activityFactor = 1.0;
    switch (activity) {
      case "sedentary":
        activityFactor = 1.15;
        break;
      case "light":
        activityFactor = 1.325;
        break;
      case "moderate":
        activityFactor = 1.42;
        break;
      case "active":
        activityFactor = 1.52;
        break;
      case "veryActive":
        activityFactor = 1.67;
        break;
      case "extraActive":
        activityFactor = 1.85;
        break;
      default:
        activityFactor = 1.0;
        break;
    }
    const proteinIntakeMin = (0.1 * bmr * activityFactor) / 4;
    const proteinIntakeMax = (0.35 * bmr * activityFactor) / 4;
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeWHO = (age, gender, weight, activity, height) => {
    let proteinIntake = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        proteinIntake = weight * 0.83;
      }
    }
    return Math.round(proteinIntake);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateProtein();
    setResultADA(result.proteinIntakeADA);
    setResultCDC(result.proteinIntakeCDC);
    setResultWHO(result.proteinIntakeWHO);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de protéines estime la quantité quotidienne de protéines alimentaires dont les adultes ont besoin pour rester en bonne santé.
                  <br /> Généralement, les enfants, ceux qui sont extrêmement actifs physiquement, et les femmes enceintes et allaitantes ont besoin de plus de protéines.
                  <br />
                  La calculatrice est également utile pour surveiller l'apport en protéines de ceux qui souffrent de maladies rénales ou hépatiques, du diabète ou d'autres conditions où l'apport en protéines est un facteur.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice de protéines corporelles
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="140"
                      value={height}
                      onChange={handleHeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>cm</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="65"
                      value={weight}
                      onChange={handleWeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>kg</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="18"
                      value={age}
                      onChange={handleAgeChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>18 - 85</span>
                  </div>

                  <div className="form-group d-flex align-items-center">
                    <b><label>Sexe</label></b>
                    <div style={{ marginRight: "40px" }}>
                      <label style={{ marginLeft: "15px" }}>
                        <input
                          type="radio"
                          value="male"
                          checked={gender === "male"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}Homme
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="female"
                          checked={gender === "female"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}Femme
                      </label>
                    </div>
                  </div>

                  <br />

                  <div>
                    <b><label className="form-label ms-2">Niveau d'activité</label></b>
                    <br />
                    <select
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px" }}
                    >
                      <option value="sedentary">Peu actif : activité physique très faible ou pas d'exercice</option>
                      <option value="light">Modérément actif : exercice léger 1-3 jours par semaine</option>
                      <option value="moderate">Activité modérée : exercice modéré 4-5 jours par semaine</option>
                      <option value="active">Très actif : exercice quotidien 3-4 fois par semaine</option>
                      <option value="veryActive">Activité intense : exercice intense 6-7 fois par semaine</option>
                      <option value="extraActive">Athlètes : exercice très intense quotidien</option>
                    </select>
                  </div>

                  <br />
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      Calculer
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}
                      onClick={() => {
                        setAge("");
                        setActivity("sedentary");
                        setGender("male");
                        setHeight("");
                        setWeight("");
                        setResultADA(null);
                        setResultCDC(null);
                        setResultWHO(null);
                        setAgeError("");
                        setHeightError("");
                        setWeightError("");
                      }}
                    >
                      Réinitialiser
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6 ">
                {resultADA &&
                  resultCDC &&
                  resultWHO &&
                  resultADA !== "0" &&
                  resultCDC !== "0" &&
                  resultWHO !== "0" ? (
                  <div>
                    <p style={{ fontWeight: "bold" }}>
                      Sur la base des informations fournies, voici les recommandations de base concernant l'apport en protéines de plusieurs organisations fiables :
                    </p>
                    <p>
                      Association Diététique Américaine (ADA) :{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultADA} grammes par jour
                      </span>
                    </p>
                    <p>
                      Centres de Contrôle et de Prévention des Maladies (CDC) :{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultCDC} grammes par jour
                      </span>
                    </p>
                    <p>
                      Minimum sûr selon l'OMS :{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultWHO} grammes par jour{" "}
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                Tout ce que vous devez savoir sur les protéines : comment les calculer et leur importance dans votre régime alimentaire
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Qu'est-ce que la protéine ?</h2>
                </u>
                <br />
                <p>
                  Les protéines sont l'un des trois aliments essentiels qui fournissent de l'énergie au corps humain, aux côtés des graisses et des glucides. Les protéines sont également responsables d'une grande partie du travail effectué dans les cellules, elles sont essentielles à la structure et au fonctionnement appropriés des tissus et des organes, et elles les régulent également. Elles sont composées d'un certain nombre d'acides aminés qui sont essentiels au fonctionnement correct du corps, et elles agissent comme les briques de base des tissus corporels.
                </p>
                <p>Il y a 20 acides aminés différents au total, et la séquence des acides aminés détermine la structure et la fonction de la protéine. Bien que certains acides aminés puissent être synthétisés dans le corps, il existe 9 acides aminés que l'homme ne peut obtenir que de sources alimentaires (des quantités insuffisantes peuvent parfois entraîner la mort), et on les appelle les acides aminés essentiels. Les aliments qui fournissent tous les acides aminés essentiels sont appelés sources de protéines complètes, et incluent à la fois les sources animales (viande, produits laitiers, oeufs et poisson) ainsi que les sources végétales (soja, quinoa et sarrasin).</p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Les protéines peuvent être classées en fonction de la fonction qu'elles remplissent dans le corps. Voici une liste de certains types de protéines :
                  </h2>{" "}
                </u>
                <br />
                <p>
                  <strong>Anticorps :</strong> Les protéines qui protègent le corps des molécules étrangères, comme les virus et les bactéries, en s'y liant.
                </p>
                <p>
                  <strong>Enzyme :</strong> Les protéines qui aident à créer de nouvelles molécules et à effectuer de nombreuses réactions chimiques qui se produisent dans tout le corps.
                </p>
                <p>
                  <strong>Messager :</strong> Les protéines qui transDéportent les signaux dans tout le corps pour maintenir les processus corporels.
                </p>
                <p>
                  <strong>Composant structurel :</strong> Les protéines qui agissent comme unités de construction pour les cellules qui permettent finalement au corps de se déplacer.
                </p>
                <hr />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Aliments riches en protéines</h3></div>
              <div className="info-section-body">
                <p>Les protéines se trouvent dans de nombreux aliments. Les sources animales sont les plus complètes (tous les acides aminés essentiels) tandis que la plupart des sources végétales sont incomplètes et doivent être combinées.</p>
                <ul>
                  <li><strong>Viandes :</strong> poulet (31 g/100g), bœuf (26 g/100g), dinde (30 g/100g)</li>
                  <li><strong>Poissons :</strong> thon (30 g/100g), saumon (25 g/100g), sardines (25 g/100g)</li>
                  <li><strong>Produits laitiers :</strong> fromage blanc 0% (11 g/100g), yaourt grec (10 g/100g)</li>
                  <li><strong>Légumineuses :</strong> lentilles cuites (9 g/100g), pois chiches cuits (9 g/100g)</li>
                  <li><strong>Autres :</strong> oeufs (13 g/100g), tofu ferme (17 g/100g), amandes (21 g/100g)</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Besoins en protéines selon le profil</h3></div>
              <div className="info-section-body">
                <p>Les besoins varient selon l’âge, le sexe et le niveau d’activité physique :</p>
                <ul>
                  <li><strong>Adulte sédentaire :</strong> 0,8 g par kg de poids corporel par jour (recommandation OMS)</li>
                  <li><strong>Adulte actif :</strong> 1,2 à 1,6 g/kg/jour</li>
                  <li><strong>Sportif de force (musculation) :</strong> 1,6 à 2,2 g/kg/jour</li>
                  <li><strong>Sportif d’endurance :</strong> 1,2 à 1,6 g/kg/jour</li>
                  <li><strong>Personnes âgées (+ 65 ans) :</strong> 1,0 à 1,2 g/kg/jour pour préserver la masse musculaire</li>
                  <li><strong>Femme enceinte :</strong> +25 g/jour supplémentaires aux besoins de base</li>
                </ul>
                <p>Un excès de protéines (au-delà de 2,5 g/kg/jour sur le long terme) peut solliciter les reins. En cas d’insuffisance rénale, les apports doivent être réduits sur avis médical.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProteinCalculator;
